(function () {
  var drawer = document.getElementById('artree-cart-drawer');
  if (!drawer) return;

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('.js-cart-drawer-toggle')) {
      e.preventDefault();
      openDrawer();
    }
    if (e.target.closest('.js-cart-drawer-close')) {
      e.preventDefault();
      closeDrawer();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });
  document.addEventListener('cart:open', openDrawer);

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function refreshDrawerSection() {
    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + '?section_id=cart-drawer' : '/?section_id=cart-drawer')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newPanel = doc.getElementById('artree-cart-drawer');
        if (newPanel) {
          drawer.innerHTML = newPanel.innerHTML;
          drawer.classList.add('is-open');
        }
      })
      .catch(function () {
        fetch('/cart.js').then(function (r) { return r.json(); }).then(updateBasicTotals);
      });
  }

  function updateBasicTotals(cart) {
    var subtotalEl = document.getElementById('artree-cart-subtotal');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    var countEl = drawer.querySelector('.artree-cart-drawer__count');
    if (countEl) countEl.textContent = '(' + cart.item_count + ')';
  }

  function addVariant(variantId, buttonEl) {
    if (!variantId) return;
    if (buttonEl) {
      buttonEl.disabled = true;
      buttonEl.classList.add('is-loading');
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        if (buttonEl) {
          buttonEl.classList.remove('is-loading');
          buttonEl.classList.add('is-added');
          if (buttonEl.classList.contains('artree-upsell-card__add')) {
            buttonEl.textContent = 'Added ✓';
          }
        }
        var isOnFullCartPage = buttonEl && !buttonEl.closest('#artree-cart-drawer');
        if (isOnFullCartPage) {
          window.location.reload();
        } else {
          openDrawer();
          refreshDrawerSection();
        }
      })
      .catch(function (err) {
        console.error('Artreestry cart add failed:', err);
        if (buttonEl) buttonEl.disabled = false;
      });
  }

  document.addEventListener('click', function (e) {
    var quickAdd = e.target.closest('.js-quick-add');
    if (quickAdd) {
      e.preventDefault();
      addVariant(quickAdd.dataset.variantId, quickAdd);
    }
  });

  function changeLineQuantity(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function () { refreshDrawerSection(); })
      .catch(function (err) { console.error('Artreestry cart change failed:', err); });
  }

  document.addEventListener('click', function (e) {
    var minus = e.target.closest('.js-qty-minus');
    var plus = e.target.closest('.js-qty-plus');
    var remove = e.target.closest('.js-qty-remove');

    if (minus) {
      var minusRow = minus.closest('.artree-cart-item__qty-stepper');
      var minusQtyEl = minusRow.querySelector('.artree-cart-item__qty');
      var newQty = Math.max(0, parseInt(minusQtyEl.textContent, 10) - 1);
      changeLineQuantity(minusRow.dataset.key, newQty);
    }
    if (plus) {
      var plusRow = plus.closest('.artree-cart-item__qty-stepper');
      var plusQtyEl = plusRow.querySelector('.artree-cart-item__qty');
      var newQtyPlus = parseInt(plusQtyEl.textContent, 10) + 1;
      changeLineQuantity(plusRow.dataset.key, newQtyPlus);
    }
    if (remove) {
      changeLineQuantity(remove.dataset.key, 0);
    }
  });

  document.addEventListener('change', function (e) {
    var checkbox = e.target.closest('.artree-giftwrap-checkbox');
    if (!checkbox) return;

    var giftWrapVariantId = checkbox.dataset.variantId;

    if (!giftWrapVariantId || giftWrapVariantId === '00000000000000') {
      console.warn('Artreestry: set a real Gift Wrapping variant ID in snippets/cart-drawer.liquid');
      return;
    }

    var isOnFullCartPage = !checkbox.closest('#artree-cart-drawer');

    if (checkbox.checked) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: parseInt(giftWrapVariantId, 10),
            quantity: 1,
            properties: { '_Gift Wrap Note': 'Includes a personalized, hand-written stone-textured card' }
          }]
        })
      }).then(function () {
        if (isOnFullCartPage) { window.location.reload(); } else { refreshDrawerSection(); }
      });
    } else {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var line = cart.items.find(function (i) { return i.variant_id === parseInt(giftWrapVariantId, 10); });
          if (line) {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: line.key, quantity: 0 })
            });
          }
        })
        .then(function () {
          if (isOnFullCartPage) { window.location.reload(); } else { refreshDrawerSection(); }
        });
    }
  });

})();
